import Box from '@zenbusiness/zui/Box';
import Card from '@zenbusiness/zui/Card';
import Chip from '@zenbusiness/zui/Chip';
import { lighten, superstyled } from '@zenbusiness/zui/styles';

import { SmartLink } from '#client/components/SmartLink';

export const TrackerCard = superstyled({
  name: 'TrackerCard',
  slot: 'Root',
  tag: Card,
  styles: () => ({
    marginBottom: 8,
  }),
});

export const ListItemContainer = superstyled({
  name: 'ListItemContainer',
  slot: 'Root',
  tag: 'div',
  styles: () => ({
    width: '100%',
  }),
});

export const StyledChip = superstyled({
  tag: Chip,
  propsNeeded: ['color'],
  styles: ({ color, theme }) => ({
    backgroundColor: lighten(theme.palette[color].light, 0.25),
    color: theme.palette[color].contrastText,
  }),
});

export const StyledOrderTrackerItem = superstyled({
  tag: Box,
  styles: ({ theme }) => ({
    cursor: 'pointer',
    transition: 'background-color 0.3s',
    '&:hover': {
      backgroundColor: theme.palette.action.hover,
    },
  }),
});

export const StyledOrderTrackerItemStatic = superstyled({
  tag: Box,
  styles: () => ({
    cursor: 'default',
  }),
});

export const ChevronSlot = superstyled({
  tag: Box,
  styles: () => ({
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    width: '1.5rem',
    flexShrink: 0,
  }),
});

export const INFO_TOOLTIP_SLOT_PROPS = {
  tooltip: {
    sx: {
      borderRadius: '1rem',
      maxWidth: '240px',
      padding: '1rem',
    },
  },
};

export const INFO_ICON_SX = { fontSize: 18, color: 'info.main', cursor: 'pointer' };

// Velo brand colors for CTA row
export const VELO_CTA_GRADIENT_START = '#E8F4F8';
export const VELO_CTA_GRADIENT_END = '#F0F7FA';

export const VeloCtaBackground = superstyled({
  tag: Box,
  styles: () => ({
    background: `linear-gradient(90deg, ${VELO_CTA_GRADIENT_START} 0%, ${VELO_CTA_GRADIENT_END} 100%)`,
    padding: '0.75rem 1rem',
  }),
});

export const UpsellFauxLink = superstyled({
  tag: SmartLink,
  styles: ({ theme }) => ({
    textDecoration: 'none',
    color: theme.palette.text.primary,
  }),
});
